(() => {
  const announcementDeadline = Number(window.ccAnnouncementExpiresAt) || Date.now() + 60000;
  let announcementTimer;
  const updateAnnouncement = () => {
    window.clearTimeout(announcementTimer);
    const remaining = announcementDeadline - Date.now();
    document.documentElement.classList.toggle('cc-announcement-expired', remaining <= 0);
    if (remaining > 0) announcementTimer = window.setTimeout(updateAnnouncement, remaining);
  };
  updateAnnouncement();
  window.addEventListener('pageshow', updateAnnouncement);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') updateAnnouncement();
  });

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cc-open-search]');
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const modal = document.querySelector('.cc-slim-header .header__search');
    if (!modal || typeof modal.open !== 'function') return;
    event.preventDefault();
    event.stopPropagation();
    const drawer = trigger.closest('header-drawer');
    const menuToggle = drawer?.querySelector('summary');
    const returnFocus = menuToggle || trigger;
    if (drawer?.mainDetailsToggle?.open) drawer.closeMenuDrawer(event, menuToggle);
    const header = modal.closest('.section-header');
    header?.classList.remove('shopify-section-header-hidden');
    const details = modal.querySelector('details');
    const restoreFocus = () => {
      if (details.open) return;
      details.removeEventListener('toggle', restoreFocus);
      const focusTarget = [returnFocus, modal.querySelector('summary'), document.querySelector('header-drawer > details > summary'), document.querySelector('.cc-collection-search__input'), document.querySelector('.cc-slim-header .header__heading-link')]
        .find((element) => element?.isConnected && element.getClientRects().length);
      focusTarget?.focus({ preventScroll: true });
    };
    details.addEventListener('toggle', restoreFocus);
    modal.open({ target: modal.querySelector('summary') });
  }, true);
})();
